// Shared constants used by ProductsPage and ProductsDialogs
export const EU_ALLERGENS = [
    "Gluten", "Crustacés", "Oeufs", "Poissons", "Arachides", "Soja",
    "Lait", "Fruits à coque", "Céleri", "Moutarde", "Sésame",
    "Sulfites", "Lupin", "Mollusques"
];

export const FOOD_FAMILIES = [
    "B.O.F.", "Bière", "Boisson sucrée", "Boulangerie & Patisserie",
    "Champagne", "Epicerie", "Fruits & Legumes", "Marée",
    "Produits laitiers", "Viande", "Eau", "Vin"
];

export const isFoodFamily = (famille) =>
    FOOD_FAMILIES.some(f => f.toLowerCase() === (famille || '').toLowerCase());
